import { render } from "./DraggableItem.vue?vue&type=template&id=2fc82866&scoped=true"
import script from "./DraggableItem.vue?vue&type=script&lang=js"
export * from "./DraggableItem.vue?vue&type=script&lang=js"

import "./DraggableItem.vue?vue&type=style&index=0&id=2fc82866&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2fc82866"

export default script